import { useParams } from "react-router-dom";
// import { questions } from "../questions";
import { useRecommendation } from "../contexts/recommendation-context";
import { yup } from "./yup";

export const getIcons = () =>
  fetch("https://apiterm-reco.fynity.in/api/rec-question-logos")
    .then(res => res.json())
    .then(res => (Array.isArray(res) ? res[0] : {}));

export const getQuestions = broker =>
  fetch(`https://apiterm-reco.fynity.in/api/rec-questions?broker=${broker}`)
    .then(res => res.json())
    .then(res => createQuestionTree(res));

export const updateAnswer = ({ enquiryId, ...answers }) =>
  fetch(`https://apiterm-reco.fynity.in/api/rec-plan?enquiry_id=${enquiryId}`, {
    method: "POST",
    body: JSON.stringify(answers),
    headers: {
      "content-type": "application/json",
    },
  });

export const postAnswers = answers =>
  fetch("https://apiterm-reco.fynity.in/api/rec-plan", {
    method: "POST",
    body: JSON.stringify(answers),
    headers: {
      "content-type": "application/json",
    },
  }).then(res => res.json());

const questionsTreeReducer = (questionsTree, question) => {
  const { tab } = question;
  if (questionsTree[tab]) {
    questionsTree[tab] = [...questionsTree[tab], question];
    return questionsTree;
  }
  questionsTree[tab] = [question];
  return questionsTree;
};

export const createQuestionTree = questions =>
  questions.reduce(questionsTreeReducer, {});

// const questionsTree = questions.reduce(questionsTreeReducer, {});

// const tabList = Object.keys(questionsTree);

export function mathcesCondition(conditionToCheck, answerGiven) {
  const getLtGtValue = ltGtCondition => ltGtCondition.split("_")[1];
  if (conditionToCheck.includes("gt")) {
    const gtValue = getLtGtValue(conditionToCheck);
    return parseInt(answerGiven) > parseInt(gtValue);
  }

  if (conditionToCheck.includes("lt")) {
    const ltValue = getLtGtValue(conditionToCheck);
    return parseInt(answerGiven) < parseInt(ltValue);
  }

  return conditionToCheck === answerGiven;
}

function useQuestion() {
  const { tab, id } = useParams();

  const { questions, answers } = useRecommendation();

  function filterQuestionByTab(question) {
    return question.tab === tab;
  }

  function findQuestionBySequence(question) {
    return question.sequence === parseInt(id);
  }

  function findNameBySequence(sequence) {
    let question = null;

    for (let tab of tabList) {
      question = questions[tab].find(
        question => question.sequence === sequence,
      );

      if (question) return question.name;
    }

    return question;
  }

  const isFirstQuestion = parseInt(id) === 1;

  let tabList = null;

  let firstQuestion = null;

  let currentQuestion = null;

  if (questions && tab) {
    const currentQuestionIndex = questions[tab].findIndex(
      question => question.sequence === parseInt(id),
    );

    currentQuestion = questions[tab][currentQuestionIndex];
  }

  if (questions) tabList = Object.keys(questions);

  if (questions) {
    const firstTab = tabList[0];
    firstQuestion = questions[firstTab][0];
    const { sequence } = firstQuestion;
    firstQuestion = { tab: firstTab, sequence };
  }

  const shouldRenderQuestion = question => {
    const { when, validation, name } = question;

    if (["child1_fees", "child2_fees", "child3_fees"].includes(name)) {
      const currentQuestionName = findNameBySequence(parseInt(id));
      if (
        ["child1_fees", "child2_fees", "child3_fees"].includes(
          currentQuestionName,
        )
      ) {
        return false;
      }
      const thisChildAge = parseInt(answers[`${name.split("_")[0]}_age`]);
      if (thisChildAge > 0 && thisChildAge < 21) {
        return true;
      }
    }

    if (validation?.pattern === "sub_question") return false;

    if (!when) return true;

    function checkCondition(condition) {
      const [question_id, conditionToCheck] = condition;
      const question_name = findNameBySequence(question_id);
      const answerGiven = answers[question_name];
      const doesMatch = mathcesCondition(conditionToCheck, answerGiven);
      return doesMatch;
    }

    if (when) return when.every(checkCondition);
  };

  const isSubQuestion = question =>
    question.validation?.pattern === "sub_question";

  const getNextQuestion = currentQuestion => {
    const { tab, sequence } = currentQuestion;

    let nextQuestion = null;

    if (questions) {
      const currentQuestionIndex = questions[tab].findIndex(
        question => question.sequence === parseInt(sequence),
      );
      nextQuestion = questions[tab][currentQuestionIndex + 1];

      if (!nextQuestion) {
        const nextTab = tabList[tabList.indexOf(tab) + 1];

        if (!nextTab) return null;

        nextQuestion = questions[nextTab][0];
      }

      if (!shouldRenderQuestion(nextQuestion))
        return getNextQuestion(nextQuestion);
    }

    return nextQuestion;
  };

  const getSubQuestions = question => {
    const { tab, sequence } = question;

    let subQuestions = [];

    if (questions) {
      const tabQuestions = questions[tab];

      const questionIndex = tabQuestions.findIndex(
        question => question.sequence === sequence,
      );

      const tabQuestionsSlice = tabQuestions.slice(questionIndex + 1);

      for (let tabQuestion of tabQuestionsSlice) {
        if (!isSubQuestion(tabQuestion)) return subQuestions;
        subQuestions = [...subQuestions, tabQuestion];
      }
    }

    return subQuestions;
  };

  return {
    tabList,
    filterQuestionByTab,
    findQuestionBySequence,
    isFirstQuestion,
    firstQuestion,
    getNextQuestion,
    shouldRenderQuestion,
    getSubQuestions,
    findNameBySequence,
    currentQuestion,
  };
}

export { useQuestion };

export function createCondition(question) {
  // let { type, when, validation } = question;
  let { type, validation } = question;

  type = !type ? "age" : type.trim();

  let schema = yup.string();

  // if (validation?.pattern === "sub_question" && when) {
  //   schema = schema.when([when.question_id], {
  //     is: val => val === when.option_name,
  //     then: yup.string().required(),
  //   });
  // } else {
  if (["text"].includes(type)) {
    schema = schema.required("This question is required!");
    if (validation?.pattern === "email") {
      const { error_message } = question;
      schema = schema.email(error_message[0]);
    }
    if (validation?.pattern === "full_name") {
      const { error_message } = question;
      schema = schema.fullName({ errorMessage: error_message });
    }
  }

  if (["number", "amount"].includes(type)) {
    const { validation } = question;
    let condition = yup.string().required("This question is required!");

    if (validation?.min && validation?.max && false) {
      const { min, max } = validation;
      condition = condition.minmax({
        min: parseInt(min),
        max: parseInt(max),
        errorMessage: `Must be between ${min} and ${max}`,
      });
    } else {
      if (validation?.min) {
        const { min } = validation;
        const { error_message } = question;
        const minIndex = Object.keys(validation).indexOf("min");
        condition = condition.minValue({
          min: parseInt(min),
          errorMessage:
            error_message[minIndex] || `Must be greater than ${min}`,
        });
      }

      if (validation?.max) {
        const { max } = validation;
        const { error_message } = question;
        const maxIndex = Object.keys(validation).indexOf("max");
        condition = condition.maxValue({
          max: parseInt(max),
          errorMessage: error_message[maxIndex] || `Must be lesser than ${max}`,
        });
      }
    }

    schema = condition;
  }

  // if (["amount"].includes(type)) {
  //   schema = yup.string().required("This question is required!");
  // }

  if (["toggle"].includes(type)) {
    schema = yup.string().nullable().required("This question is required!");
  }
  // }

  return schema;
}

export function createSchema(questions = [], answers) {
  return yup.object().shape(
    questions.reduce((schema, question) => {
      const { validation, when, name } = question;
      if (validation?.pattern === "sub_question" && when) {
        // if (["child1_fees", "child2_fees", "child3_fees"].includes(name)) {
        //   if (answers["children_count"] > 0) {
        //     if (name === "child1_age") {
        //       return { ...schema, [name]: createCondition(question) };
        //     }
        //   }
        //   if (answers["children_count"] > 1) {
        //     if (name === "child2_age") {
        //       return { ...schema, [name]: createCondition(question) };
        //     }
        //   }
        //   if (answers["children_count"] > 2) {
        //     if (name === "child3_age") {
        //       return { ...schema, [name]: createCondition(question) };
        //     }
        //   }
        //   return schema;
        // }
        if (["child2_fees", "child3_fees"].includes(name)) {
          let when = name === "child2_fees" ? ["child2_age"] : ["child3_age"];

          let is = val => {
            const answerGiven =
              answers[name === "child2_fees" ? "child2_age" : "child3_age"];

            return answerGiven > 0 && answerGiven < 21;
          };

          return {
            ...schema,
            [question.name]: yup.string().when(when, {
              is,
              then: (() => {
                const s = createCondition(question);
                if (process.env.NODE_ENV === "development") console.log(s);
                return s;
              })(),
            }),
          };
        }
        if (["child2_age", "child3_age"].includes(name)) {
          let is;
          if (name === "child2_age") {
            is = val => answers["children_count"] > 1;
          }
          if (name === "child3_age") {
            is = val => answers["children_count"] > 2;
          }
          return {
            ...schema,
            [question.name]: yup.string().when(["children_count"], {
              is,
              then: (() => {
                const s = createCondition(question);
                if (process.env.NODE_ENV === "development") console.log(s);
                return s;
              })(),
            }),
          };
        }
        return {
          ...schema,
          [question.name]: yup.string().when([when[0].question_id], {
            is: val => val === when[0].option_name,
            then: (() => {
              const s = createCondition(question);
              if (process.env.NODE_ENV === "development") console.log(s);
              return s;
            })(),
          }),
        };
      }
      if (validation?.pattern === "sub_question") return schema;
      return {
        ...schema,
        [question.name]: createCondition(question),
      };
    }, {}),
  );
}
